<template>
    <div>
        <CCTableAddItems
            :items="tables.executeConditions.items"
            :fields="tables.executeConditions.fields"
            :resizable="false"
        >
            <template #fieldName="{ index }">
                <SelectAsync
                    :value.sync="
                        tables.executeConditions.items[index].fieldName
                    "
                    :options="fieldsModel"
                    :placeholder="$t('select_a_field')"
                    :invalidFeedback="$t('fied_is_required')"
                    size="sm"
                    class="mb-0"
                />
            </template>

            <template #condition="{ index }">
                <SelectAsync
                    :value.sync="
                        tables.executeConditions.items[index].condition
                    "
                    :options="traslateLabels(conditions)"
                    :optionsValue="'value'"
                    :optionsLabel="'label'"
                    :placeholder="$t('select_an_option')"
                    :invalidFeedback="$t('field_is_required')"
                    class="mb-0"
                    size="sm"
                />
            </template>

            <template #value="{ index }">
                <SelectAsync
                    v-if="
                        tables.executeConditions.items[index].fieldName ==
                        'provider_id'
                    "
                    :value.sync="tables.executeConditions.items[index].value"
                    :placeholder="$t('select_an_option')"
                    size="sm"
                    :optionsValue="'id'"
                    :optionsLabel="'name'"
                    :endpoint="'provider'"
                />
                <SelectAsync
                    v-else-if="
                        tables.executeConditions.items[index].fieldName ==
                        'client_id'
                    "
                    :value.sync="tables.executeConditions.items[index].value"
                    :placeholder="$t('select_an_option')"
                    size="sm"
                    optionsValue="id"
                    optionsLabel="name"
                    endpoint="campaigns.api"
                />
                <CInput
                    v-else
                    :value.sync="tables.executeConditions.items[index].value"
                    :placeholder="$t('enter_the_value')"
                    :invalidFeedback="$t('value_is_required')"
                    class="mb-0"
                    size="sm"
                />
            </template>

            <template #percentage="{ index }">
                <input
                    v-model="tables.executeConditions.items[index].percentage"
                    placeholder="Enter a percentage"
                    type="range"
                    :class="[
                        'mb-0',
                        'w-100',
                        !tables.executeConditions.items[index].percentage
                            ? 'range__not_defined'
                            : '',
                    ]"
                    size="sm"
                />
                <br />
                Percentage:
                {{ tables.executeConditions.items[index].percentage }} %
            </template>


        </CCTableAddItems>
    </div>
</template>

<script>
/**Components */
import SelectAsync from "£lement/SelectAsync";
import CCTableAddItems from "~/components/CCTableAddItems";

/** Mixins */
import tableMixin from "~/mixins/table.js";
import traslateMixin from "~/mixins/traslate.js";

/** Others */
import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilPlus,
} from "@coreui/icons";
import FilterTypeOptions from "~/pages/app/config/options/filter_type";

export default {
    name: "EventExecuteConditionsManager",
    mixins: [traslateMixin, tableMixin],
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilPlus,
    },
    options: {
        filterType: FilterTypeOptions,
    },
    components: {
        SelectAsync,
        SelectAsync,
        CCTableAddItems,
    },
    data() {
        return {
            tables: {
                executeConditions: {
                    items: [],
                    fields: [
                        {
                            key: "fieldName",
                            label: "field_name",
                            sorter: false,
                            filter: false,
                            _style: "width:30%",
                        },
                        {
                            key: "condition",
                            label: "condition",
                            sorter: false,
                            filter: false,
                            _style: "width:20%",
                        },
                        {
                            key: "value",
                            label: "value",
                            sorter: false,
                            filter: false,
                            _style: "width:30%",
                        },
                        {
                            key: "percentage",
                            label: "percentage",
                            sorter: false,
                            filter: false,

                            _style: "width:30%",
                        }
                    ],
                },
            },
            modals: {},
            modelFields: [],
        };
    },
    props: {
        fieldsModel: Array,
        conditions: Array,
        value: Array,
    },
    watch: {
        "tables.executeConditions.items": {
            handler(newValue) {
                this.$emit("update:value", newValue);
                this.$emit("change", newValue);
            },
            deep: true,
        },
    },
    methods: {
        addExecuteCondition() {
            let newItem = this.addItemToTable("executeConditions");

            // Set by defult item.condition to equal why is the only options available
            this.$set(newItem.item, "condition", "equal");
            this.$set(newItem.item, "percentage", 100);
        },
    },
    mounted() {
        if (Array.isArray(this.value))
            this.tables.executeConditions.items = this.value;
    },
};
</script>

<style>
.range__not_defined {
    accent-color: gray;
}
</style>
